import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useAppSelector} from '@/hooks';

export function RectangleRoundnessOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemRx = useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item && 'rx' in item) {
      return item.rx;
    }
    return undefined;
  });

  if (!activeItem || (activeItem && !activeItem.isRectangle()) || itemRx === undefined) {
    throw new Error(`Item is not a rectangle in rectangle roundness option`);
  }

  const updateRoundness = async (val: number, undoable = true): Promise<void> => {
    await activeItem.updateFromObject(
      {
        rx: val,
        ry: val,
      },
      {
        undoable,
      }
    );
  };

  return (
    <ContextualMenuSliderOptions
      id="rectangle-roundness-option"
      range={{
        min: 0,
        max: 100,
      }}
      transformDisplay={{
        min: 0,
        max: 100,
      }}
      step={1}
      value={itemRx}
      label={window.i18next.t('pmwjs_roundness')}
      onChange={(val: number): void => {
        void updateRoundness(val, false);
      }}
      onChangeEnded={(val: number): void => {
        void updateRoundness(val, true);
      }}
    />
  );
}
